export default __webpack_public_path__ + "asset/mongolia.d534988020207b2b9b03b81e8e3318d0.svg";